var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }),
      createElementVNode("path", { d: "M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2" }),
      createElementVNode("path", { d: "m10 18l5-5a1.414 1.414 0 0 0-2-2l-5 5v2z" })
    ], -1)
  ]));
}
__name(render, "render");
const filePencil = markRaw({ name: "tabler-file-pencil", render });
export {
  filePencil as default
};
//# sourceMappingURL=file-pencil.js.map
